import request from '@/utils/request'

export function fetchList(parentId, params) {
  return request({
    url:'/category/list/' + parentId,
    method:'get',
    params:params
  })
}
export function deleteCategory(id) {
  return request({
    url:'/category/delete/' + id,
    method:'post'
  })
}

export function createCategory(data) {
  return request({
    url:'/category/create',
    method:'post',
    data:data
  })
}

export function updateCategory(id, data) {
  return request({
    url:'/category/update/' + id,
    method:'post',
    data:data
  })
}

export function getCategory(id) {
  return request({
    url:'/category/' + id,
    method:'get',
  })
}

export function getAttributeCategoryIdList(id) {
  return request({
    url: '/category/listAttributeCategory/' + id,
    method: 'get',
  })
}

export function fetchListWithChildren() {
  return request({
    url:'/category/list/withChildren',
    method:'get'
  })
}
